import {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {ObjectUtils} from "../Utils/ObjectUtils";

const isExternalUrl = (url) => {
    if(!url || typeof url !== 'string') {
        return false;
    }

    const lower = url.toLowerCase();
    return lower.startsWith('http://') || lower.startsWith('https://');
};

export const useChangePage = () => {
    const navigate = useNavigate();

    return useCallback((url, keepPreviousPageInHistory = true) => {
        if(isExternalUrl(url)) {
            window.location.href = url;
            return;
        }

        if(keepPreviousPageInHistory) {
            navigate(url);
        } else {
            navigate(url, {replace: true});
        }
    }, [navigate]);
};

export const usePushQueryStringUpdate = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback((query) => {
        const search = query ? `?${ObjectUtils.BuildQueryString(query)}` : '';

        navigate({
            pathname: location.pathname,
            search
        });
    }, [navigate, location.pathname]);
};
